import { useId } from "react"

/**
 * Decorative sun + rays for the top-right corner of the hero. Pairs with the
 * grass-through-panel art at the bottom corners and the care-plan polaroid
 * at bottom-left to suggest "sun → lawn → plan."
 */
export function HeroSunlight() {
  const idPrefix = `hero-sun-${useId().replace(/:/g, "")}`
  const fillId = `${idPrefix}-fill`
  const haloId = `${idPrefix}-halo`

  return (
    <svg
      viewBox="0 0 160 160"
      role="presentation"
      aria-hidden="true"
      className="w-full h-auto"
    >
      <defs>
        <radialGradient id={fillId} cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#fef3c7" />
          <stop offset="55%" stopColor="#fcd34d" />
          <stop offset="100%" stopColor="#f59e0b" />
        </radialGradient>
        <radialGradient id={haloId} cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#fde68a" stopOpacity="0.55" />
          <stop offset="60%" stopColor="#fef3c7" stopOpacity="0.2" />
          <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
        </radialGradient>
      </defs>

      <circle cx="105" cy="55" r="68" fill={`url(#${haloId})`} />
      <circle cx="105" cy="55" r="16" fill={`url(#${fillId})`} />

      <g stroke="#f59e0b" strokeWidth="2.6" strokeLinecap="round" opacity="0.85">
        <line x1="105" y1="29" x2="105" y2="14" />
        <line x1="124" y1="36" x2="135" y2="25" />
        <line x1="131" y1="55" x2="148" y2="55" />
        <line x1="124" y1="74" x2="135" y2="85" />
        <line x1="105" y1="81" x2="105" y2="96" />
        <line x1="86" y1="74" x2="75" y2="85" />
        <line x1="79" y1="55" x2="62" y2="55" />
        <line x1="86" y1="36" x2="75" y2="25" />
      </g>

      {/* Two faint sparkles for delight */}
      <g fill="#fcd34d" opacity="0.7">
        <path d="M 50 100 l 1.4 2.8 l 2.8 1.4 l -2.8 1.4 l -1.4 2.8 l -1.4 -2.8 l -2.8 -1.4 l 2.8 -1.4 z" />
        <path d="M 145 105 l 1 2 l 2 1 l -2 1 l -1 2 l -1 -2 l -2 -1 l 2 -1 z" />
      </g>
    </svg>
  )
}
